import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { NgxPaginationModule } from 'ngx-pagination';

import { RouterModule, Routes, Router } from '@angular/router';
import {APP_BASE_HREF} from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TinymceModule } from 'angular2-tinymce';
// ===================== 
// Ngx Bootstrap 
// ===================== 
import { ModalModule, CarouselModule, CollapseModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { NgxCarouselModule } from 'ngx-carousel';
import { SampleComponent } from './components/carousel/item-content';
import { itemDetail } from './components/carousel/item-detail';
import { PomotionNews } from './components/carousel/news-promotion';
import { NewsPomotion } from './components/carousel/item-newsPomotions';
import { DrinksComponent } from './components/carousel/item-content-drink'
import { DriedComponent } from './components/carousel/item-content-dried'
import { RiceComponent } from './components/carousel/item-content-rice'
import 'hammerjs';

// =====================
// Pages
// ===================== 
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { ContentComponent } from './content/content.component';
import { FooterComponent } from './footer/footer.component';
import { RecommentProductComponent } from './components/recomment-product/recomment-product.component';
import { CartComponent } from './components/cart/cart.component';
import { RiceSpacialComponent } from './components/rice-spacial/rice-spacial.component'
import { DriedFoodComponent } from './components/dried-food/dried-food.component';
import { DrinkComponent } from './components/drink/drink.component';
import { DetailItemComponent } from './components/detail-item/detail-item.component';
import { MemberComponent } from './components/member/member.component'
import { SupplementComponent } from './components/supplement/supplement.component';
import { LoginComponent } from './components/login/login.component';
import { DetailOrderComponent } from './components/detail-order/detail-order.component'
import { DetailHistoryComponent } from './components/detail-history/detail-history.component';
import { EditProductComponent } from './components/edit-product/edit-product.component';
import { DetailNewsComponent } from './components/detail-news/detail-news.component';
import { DetailItemPromotionNewsComponent } from './components/detail-item-promotion-news/detail-item-promotion-news.component';
import { EditNewsComponent } from './components/edit-news/edit-news.component';
import { EditAdvertiseComponent } from './components/edit-advertise/edit-advertise.component';
import { AdminComponent } from './admin/admin.component';
import { HomePageComponent } from './home-page/home-page.component';
import { ProductListComponent } from './admin/page/product-list/product-list.component';
import { DashbroadComponent } from './admin/page/dashbroad/dashbroad.component';
import { UserComponent } from './admin/page/user/user.component';
import { OrderedComponent } from './admin/page/ordered/ordered.component';
import { AddproductComponent } from './admin/page/product-list/view/addproduct/addproduct.component';
import { SlideBrandComponent } from './admin/page/slide-brand/slide-brand.component';
import { NewsComponent } from './admin/page/news/news.component';
import { NewslistComponent } from './admin/page/news/view/newslist/newslist.component';
import { AddnewsComponent } from './admin/page/news/view/addnews/addnews.component';
import { ProtectHairComponent } from './components/carousel/item-content-protect-hair';
import { ProtectSkinComponent } from './components/carousel/item-content-protect-skin';
import { ShowerComponent } from './components/carousel/item-content-shower';



import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database-deprecated';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { firebaseConfig } from './../environments/firebase.config'
import { LocationStrategy, HashLocationStrategy} from '@angular/common';
// =====================
// Services
// ===================== 
import { ProductService } from './services/product.service';
import { CartService } from './services/cart.service';
import { AuthService } from './services/AuthService';
import { BuyService } from './services/buyservice'
import { MemberService } from './services/memberService';
import { uploadService } from './services/uploadService';
import { NewsService } from './services/newsService';
import { SearchComponent } from './components/search/search.component';
import { SearchItemService } from './services/searchService';
import { ServiceHeader } from './services/serviceHeader';
import { FilterPipe } from './components/search/pipe';
import { OrderlistComponent } from './admin/page/ordered/orderlist/orderlist.component';
import { ListproductComponent } from './admin/page/product-list/view/listproduct/listproduct.component';
import { EditorComponent } from './helpers/editor/editor.component';
import { CartModalComponent } from './components/cart-modal/cart-modal.component';
import { OrderSuccessComponent } from './components/order-success/order-success.component';
import { ModalLineComponent } from './components/modal-line/modal-line.component';
import { EditMetaTagComponent } from './admin/page/edit-meta-tag/edit-meta-tag.component';
import { ItemProductComponent } from './components/item-product/item-product.component';
import { TypepageComponent } from './admin/page/typepage/typepage.component';
import { TypelistComponent } from './admin/page/typepage/view/typelist/typelist.component';
import { TypeaddComponent } from './admin/page/typepage/view/typeadd/typeadd.component';
import { TypeeditComponent } from './typepage/view/typeedit/typeedit.component';



const appRoutes: Routes = [
  {
    path: "",
    children: [
      { path: "", component: ContentComponent },
      { path: "Search", component: SearchComponent },
      { path: "สินค้าแนะนำ", component: RecommentProductComponent },
      { path: "Cart", component: CartComponent },
      { path: "ข้าวไทยเกรดพรีเมี่ยม", component: RiceSpacialComponent },
      { path: "อาหารอบแห้ง", component: DriedFoodComponent },
      { path: "เครื่องดื่ม", component: DrinkComponent },
      { path: "อาหารเสริมและสมุนไพร", component: SupplementComponent },
      { path: "Member", component: MemberComponent },
      { path: "Member/detailHistoy/:id", component: DetailHistoryComponent },
      { path: "Login", component: LoginComponent },
      { path: "Detail-Item/:id", component: DetailItemComponent },
      { path: "Detail-News-items/:id", component: DetailItemPromotionNewsComponent },
      { path: "Detail-News", component: DetailNewsComponent },
      { path: "rice-spacial/Cart", component: CartComponent },
      { path: "Dried-food/Cart", component: CartComponent },
      { path: "Recomment/Cart", component: CartComponent },
      { path: "SuccessPage/:id", component: OrderSuccessComponent },
      { path: "product/:id", component: ItemProductComponent },
    ],
    component: HomePageComponent
  },
  {
    path: "admin",
    children: [
      { path: "", redirectTo: 'dashbroad', pathMatch: 'full' },
      { path: "EditTagMeta", component: EditMetaTagComponent },
      { path: "dashbroad", component: DashbroadComponent },
      {
        path: "product", children: [
          { path: "", component: ListproductComponent },
          { path: "Edit/:id", component: EditProductComponent },
          { path: "AddProduct", component: AddproductComponent },
        ],
        component: ProductListComponent
      },
      { path: "user", component: UserComponent },
      { path: "slide-brand", component: SlideBrandComponent },
      {
        path: "order",
        children: [
          { path: "", component: OrderlistComponent },
          { path: "orderlistM", redirectTo: '', pathMatch: 'full' },
          { path: "orderlist/:id", component: DetailOrderComponent }
        ], component: OrderedComponent
      },
      {
        path: "news",
        children: [
          { path: "", component: NewslistComponent },
          { path: "addnews", component: AddnewsComponent },
          { path: "edit/:id", component: EditNewsComponent }
        ], component: NewsComponent
      },
      {
        path: "Type",
        children: [
          { path: "", component: TypelistComponent },
          { path: "Add", component: TypeaddComponent },
          { path: "Edit/:id", component: TypeeditComponent },
        ], component: TypepageComponent
      }
    ],
    component: AdminComponent
  },
  { path: '**', redirectTo: '' },
]


@NgModule({
  declarations: [
    AppComponent, FilterPipe,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    RecommentProductComponent,
    CartComponent,
    RiceSpacialComponent,
    DriedFoodComponent,
    DrinkComponent, SampleComponent, DetailItemComponent, itemDetail, PomotionNews, DrinksComponent, NewsPomotion,
    DriedComponent, RiceComponent, MemberComponent, SupplementComponent, LoginComponent, DetailOrderComponent, DetailHistoryComponent, EditProductComponent, DetailNewsComponent, DetailItemPromotionNewsComponent, EditNewsComponent, EditAdvertiseComponent, SearchComponent, AdminComponent, HomePageComponent, ProductListComponent, DashbroadComponent, UserComponent, OrderedComponent, OrderlistComponent, ListproductComponent, EditorComponent
    , AddproductComponent, SlideBrandComponent, NewsComponent, NewslistComponent, EditMetaTagComponent, ItemProductComponent, TypepageComponent, TypelistComponent, TypeaddComponent, TypeeditComponent, AddnewsComponent, CartModalComponent, OrderSuccessComponent, ModalLineComponent,ProtectHairComponent
    , ProtectSkinComponent,ShowerComponent
  ],
  imports: [
    TooltipModule.forRoot(),
    TinymceModule.withConfig({}),
    NgxPaginationModule,
    BrowserModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    NgxCarouselModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [
    ProductService, CartService, AuthService, BuyService, MemberService, uploadService, NewsService, SearchItemService, ServiceHeader,{ provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/app.module.ts